/**
 * 逻辑出库单/逻辑入库单新增
 * @param {*} config 
 * @returns 
 */
const request = (config) => {
  const { tableName } = vm.$route.params;
  // 根据业务单据类型关联不同通知单表【出库通知单、入库通知单 - colid】
  if (['SG_B_STO_OUT_RESULT', 'SG_B_STO_IN_RESULT'].includes(tableName) && vm.$route.params.itemId == 'New' && config.url == '/p/cs/newQueryList') {
    let all = new URLSearchParams(config.data)
    let flag = false
    const params = new URLSearchParams()
    all.forEach((val, key) => {
      if (key == 'searchdata') {
        const searchdata = JSON.parse(val)
        if ([1700828555, 1700828556].includes(searchdata.refcolid)) {
          flag = true
          const { SOURCE_BILL_TYPE } = vm.$store.state[R3.getModuleName()].updateData[tableName].changeData
          const config = {
            SG_B_STO_IN_RESULT: {
              0: 1700828556, // 默认
              62: 1700854756, // 入库通知单-TOB
              65: 1700854756, // 入库通知单-TOB
            },
            SG_B_STO_OUT_RESULT: {
              0: 1700828555, // 默认
              62: 1700854755, // 出库通知单-TOB
              65: 1700854755, // 出库通知单-ToB
            }
          }
          let refcolid = config[tableName][0] 
          // 修改数据后清空changeData并未清空存的上次的值，故结合$('#SOURCE_BILL_TYPE input').val()
          SOURCE_BILL_TYPE && $('#SOURCE_BILL_TYPE input').val() != '' && (refcolid = config[tableName][SOURCE_BILL_TYPE] || config[tableName][0])
          searchdata.refcolid = refcolid
          params.append('searchdata', JSON.stringify(searchdata));
        }
      } else {
        params.append(key, val);
      }
    })
    flag && (config.data = params)
  }

  // 逻辑出库单/逻辑入库单新增- 逻辑仓定制查询
  const tzTable = new Map([
    ['SG_B_STO_OUT_RESULT', { tipField: '出库通知单', refcolid: 1700822361, noticeColname: 'SG_B_STO_OUT_NOTICES_ID', resultType: 1 }],
    ['SG_B_STO_IN_RESULT', { tipField: '入库通知单', refcolid: 1700822455, noticeColname: 'SG_B_STO_IN_NOTICES_ID', resultType: 2 }],
  ])
  if (tzTable.get(tableName) && vm.$route.params.itemId == 'New' && config.url == '/p/cs/newQueryList') {
    const { tipField, refcolid, noticeColname, resultType } = tzTable.get(tableName)
    let flag = false
    let conds = {
      startindex: 0,
      range: 10,
      resultType
    }
    let all = new URLSearchParams(config.data)
    all.forEach((val, key) => {
      if (key == 'searchdata') {
        const configParam = JSON.parse(val)
        if (configParam.refcolid == refcolid) {
          flag = true
          conds = { ...conds, ...configParam }
          if (conds.hasOwnProperty('ak')) { // 模糊搜索
            conds.search = conds.ak
            delete conds.ak
          }
        }
      }
    })
    if (flag) {
      const changeData = vm.$store.state[R3.getModuleName()].updateData[tableName].changeData
      if (!(changeData[noticeColname] && changeData[noticeColname].length)) {
        $fcWarn({ content: `请选择业务单据类型、${tipField}` })
        return false
      }
      if ($('#SOURCE_BILL_TYPE input.ark-select-input').val() == '') { // isNaN(Number(changeData.SOURCE_BILL_TYPE)) 注意：业务类型清空框架回填了中文，故用isNaN(Number())转一下
        $fcWarn({ content: '请选择业务单据类型' })
        return false
      }
      conds.sourceBillType = changeData.SOURCE_BILL_TYPE,
      conds.noticesId = changeData[noticeColname][0].ID,
      config.url = '/api/cs/sg/store/query'
      let params = new FormData();
      for (let key in conds) {
        params.append(key, conds[key]);
      }
      config.data = params;
    }
  }

}

const response = (config) => {
  const { tableName } = vm.$route.params;
  // 隐藏主表字段
  const hideColname = new Map([
    ['SG_B_STO_IN_RESULT', 1700835557], // 逻辑入库单
    ['SG_B_STO_OUT_RESULT', 1700835556], // 逻辑出库单
  ])
  if (hideColname.get(tableName) && vm.$route.params.itemId == 'New') {
    // 逻辑出库单/逻辑入库单新增- 隐藏主表字段
    if (config.config.url == '/p/cs/getObject') {
      config.data.data.addcolums[0].childs = config.data.data.addcolums[0].childs.filter(i => i.colid != hideColname.get(tableName))
    }
    // 逻辑出库单/逻辑入库单新增- 逻辑仓定制查询
    if (config.config.url == '/api/cs/sg/store/query') {
      for (let key in config.data) {
        let val = config.data[key]
        if (key == 'datas') {
          val.tabth = [
            {
              colname: 'ID',
              name: '编码',
              isak: false,
            },
            {
              colname: 'ENAME',
              name: '名称',
              isak: true,
            },
            {
              colname: 'ECODE',
              name: '实体仓',
              isak: false,
            },
          ];
        }
      }
    }
  }
}

export default { request, response }